export default {
  billingCycle: false,
  numberOfUsersOverride: false,
  numberOfAdditionalUsersOverride: false,
  modalIsOpen: false,
  modalPlanCode: '',
  plans: [],
  error: false,
  modalPending: false,
  isBillingDetailsOpen: false,
  activeCoupon: {},
  couponError: '',
  multipleModalPage: 0,
  disableConfirmPlanBtn: false,
  loading: false,
};
